import GiftBox from "./components/GiftBox"
import GiftCard from "./components/GiftCard"
import HamburgerIcon from "./components/HamburgerIcon"
import MobileNavigation from "./components/MobileNavigation"
import ProductForm from "./components/ProductForm"
import ProductGallery from "./components/ProductGallery"
import ProductVariantSelector from "./components/ProductVariantSelector"
import ShoppingCart from "./components/ShoppingCart"
import SiteSearch from "./components/SiteSearch"
import Slideshow from "./components/Slideshow"

window.PCP = {
  instances: {},
  GiftBox: GiftBox,
  GiftCard: GiftCard,
  HamburgerIcon: HamburgerIcon,
  MobileNavigation: MobileNavigation,
  ProductForm: ProductForm,
  ProductGallery: ProductGallery,
  ProductVariantSelector: ProductVariantSelector,
  ShoppingCart: ShoppingCart,
  SiteSearch: SiteSearch,
  Slideshow: Slideshow
}
